import { AppText, AppSpan, GridContainer, Button } from "src/style";
import './style.scss';
import ApkDownloadIcon from 'src/assets/img/apk-download.svg'
import helpers from "src/utils/helpers";
import utility, { moneyFormat } from "src/utils/utility";
import { capsule } from "../capsule";
import { ISurveyTriggers, statusMap, transactionTyeMap } from "src/model";
import { FiEdit, FiTrash } from "react-icons/fi";


export const transferReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.transfer.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.name')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.senderAccountName}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.beneficiary')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.recipientAccountName}</AppText>,
        width: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount)}</AppText>,
        minWidth: '18rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.recipientAccountNumber}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.transfer')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.transferType}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.transactionDateTime ? helpers.handleDate(row.transactionDateTime) : row?.transactionDateTime}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.transactionStatus === 'Successful' ? '#ECFDF3' : '#FEF3F2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.transactionStatus === 'Successful' ? '#12B76A' : '#B42318'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.transactionStatus}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: <p className="table-column-title">{t('report.transfer.table.description')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.responseDescription || "-"}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
]


export const crossBorderPaymentColumns =(t:any)=> [
    {
        name: <p className="table-column-title">{t('report.cbp.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerId}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{helpers.handleDate(row.transactionDate) }</AppText>,
        wrap: true,
        minWidth: '15rem'
    },

    {
        name: <p className="table-column-title">{t('report.cbp.table.type')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.transactionType}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.senderAccount')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.debitAccountNumber}</AppText>,
        sortable: true,
        width: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.senderCurrency')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.debitCurrency}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{ moneyFormat(row.debitAmount)}</AppText>,
        width: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.status === "Successful" ? '#ECFDF3' : (row.status === "Failed") ? '#FFF5F5':'#fef7f2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === "Successful" ? '#12B76A' : (row.status === "Failed") ? '#B42318' : '#F59E0B'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                > 
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
        minWidth: '15rem'
    },
    // {
    //     name: <p className="table-column-title">Recipients Account</p>,
    //     selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.creditAccountNumber}</AppText>,
    //     minWidth: '18rem',
    //     wrap: true,
    // },
    {
        name: <p className="table-column-title">{t('report.cbp.table.receiverCurrency')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.creditCurrency}</AppText>,
        wrap: true,
        minWidth: '18rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.received')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{moneyFormat(row.creditAmount)}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.cbp.table.rate')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{moneyFormat(Number(1/row.exchangeRate).toFixed(2))}</AppText>,
        wrap: true,
        minWidth: '20rem'
    }
]

export const crossBorderCustomers=(t:any) => [
    {
        name: <p className="table-column-title">{t('customer.cbp.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerId}</AppText>,
        wrap: true,
        minWidth: '10rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.intlCustomerId')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.internationalCustomerId}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.primary')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.primaryAccountNumber}</AppText>,
        minwidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.name')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.firstName} {row?.lastName}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.nationality')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.nationality}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('customer.cbp.table.status')}</p>,
        minWidth:'20rem',
        selector: (row: any) => {
            let bgColor = '#FEF3F2';
            let textColor = '#B42318';
            let statusText = 'Failed';
            switch (row.status) {
                case 'Submitted':
                    bgColor = '#E0F2FE';
                    textColor = '#0369A1';
                    statusText = 'Submitted';
                    break;
                case 'Approved':
                    bgColor = '#ECFDF3';
                    textColor = '#12B76A';
                    statusText = 'Approved';
                    break;
                case 'IndemnityRejected':
                    bgColor = '#FEF3F2';
                    textColor = '#B42318';
                    statusText = 'indemnityRejected';
                    break;
                case 'IndemnityApproved':
                    bgColor = '#ECFDF3';
                    textColor = '#027A48';
                    statusText = 'indemnityApproved';
                    break;
                case 'OngoingAmlScreening':
                    bgColor = '#FEFCE8';
                    textColor = '#92400E';
                    statusText = 'ongoingAmlScreening';
                    break;
                case 'AmlScreeningPassed':
                    bgColor = '#ECFDF3';
                    textColor = '#12B76A';
                    statusText = 'AmlScreeningPassed';
                    break;
                case 'AmlScreeningFailed':
                    bgColor = '#FEF3F2';
                    textColor = '#B42318';
                    statusText = 'AmlScreeningFailed';
                    break;
            }
            return (
                <GridContainer
                    width='auto' sizeUnit="" minHeight='2.2'
                    bgColor={bgColor}
                    topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                >
                    <AppSpan
                        color={textColor}
                        textSize='1.2' leftPadding='0.5' fontWeight='500'
                    >
                        {statusText}
                    </AppSpan>
                </GridContainer>
            )
        },
    },
]


export const transferReportData = [
    {
        "sn": 1,
        "customerID": "000006",
        "profileID": 2,
        "profile": null,
        "senderAccountNumber": "1100000045",
        "senderAccountName": "Ridwan Kolawole",
        "recipientAccountNumber": "110000000034",
        "recipientAccountName": "Another",
        "recipientBankName": "GTBank",
        "recipientBankCode": null,
        "transactionDateTime": "2023-04-06T12:23:08",
        "transactionReference": "string",
        "amount": 1000,
        "narration": "Testing data api",
        "transactionStatus": "Successful",
        "responseCode": " ",
        "responseDescription": " ",
        "transferType": "Other bank",
        "authenticationType": "PINOnly",
        "scheduledTransferReference": null,
        "expenseCategory": null,
        "terminalType": 0,
        "id": 2,
        "ibInstitutionCode": 1
      },
      {
        "sn": 2,
        "customerID": "000006",
        "profileID": 2,
        "profile": null,
        "senderAccountNumber": "1100000045",
        "senderAccountName": "Some test",
        "recipientAccountNumber": "110000000034",
        "recipientAccountName": "Another",
        "recipientBankName": "GTBank",
        "recipientBankCode": null,
        "transactionDateTime": "2023-04-05T12:23:08",
        "transactionReference": "string",
        "amount": 1000,
        "narration": "Testing data api",
        "transactionStatus": "Successful",
        "responseCode": " ",
        "responseDescription": " ",
        "transferType": "Other bank",
        "authenticationType": "PINOnly",
        "scheduledTransferReference": null,
        "expenseCategory": null,
        "terminalType": 0,
        "id": 3,
        "ibInstitutionCode": 1
      },
      {
        "sn": 3,
        "customerID": "000006",
        "profileID": 2,
        "profile": null,
        "senderAccountNumber": "1100000045",
        "senderAccountName": "Some test",
        "recipientAccountNumber": "110000000034",
        "recipientAccountName": "Another",
        "recipientBankName": "GTBank",
        "recipientBankCode": null,
        "transactionDateTime": "2023-04-06T00:00:00",
        "transactionReference": "string",
        "amount": 1000,
        "narration": "Testing data api",
        "transactionStatus": "Successful",
        "responseCode": " ",
        "responseDescription": " ",
        "transferType": "Other bank",
        "authenticationType": "PINOnly",
        "scheduledTransferReference": null,
        "expenseCategory": null,
        "terminalType": 0,
        "id": 4,
        "ibInstitutionCode": 1
      },
      {
        "sn": 4,
        "customerID": "000005",
        "profileID": 25,
        "profile": null,
        "senderAccountNumber": "1100000054",
        "senderAccountName": "Awa",
        "recipientAccountNumber": "1234567899",
        "recipientAccountName": "Jane",
        "recipientBankName": "ACCESS BANK",
        "recipientBankCode": null,
        "transactionDateTime": "2023-04-17T16:59:54",
        "transactionReference": " ",
        "amount": 100,
        "narration": "Testing",
        "transactionStatus": "Successful",
        "responseCode": " ",
        "responseDescription": " ",
        "transferType": "OtherBank",
        "authenticationType": "PINOnly",
        "scheduledTransferReference": null,
        "expenseCategory": null,
        "terminalType": 0,
        "id": 5,
        "ibInstitutionCode": 1
      },
      {
        "sn": 5,
        "customerID": "000005",
        "profileID": 25,
        "profile": null,
        "senderAccountNumber": "1100000054",
        "senderAccountName": "Awa",
        "recipientAccountNumber": "1234567899",
        "recipientAccountName": "Jane",
        "recipientBankName": "ACCESS BANK",
        "recipientBankCode": null,
        "transactionDateTime": "2023-04-17T17:04:52",
        "transactionReference": " ",
        "amount": 100,
        "narration": "Testing",
        "transactionStatus": "Successful",
        "responseCode": " ",
        "responseDescription": " ",
        "transferType": "OtherBank",
        "authenticationType": "PINOnly",
        "scheduledTransferReference": null,
        "expenseCategory": null,
        "terminalType": 0,
        "id": 6,
        "ibInstitutionCode": 1
      },
]


// ====================== BILL PAYMENT REPORT =================

export const billPaymentReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.bills.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.name')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountName}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.payment')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.paymentItemName}</AppText>,
        width: '25rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.category')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.billerCategoryName}</AppText>,
        width: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.biller')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.billerName}</AppText>,
        width: '20rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount)}</AppText>,
        minWidth: '18rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.dateLogged ? helpers.handleDate(row.dateLogged) : row?.dateLogged}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.bills.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.status === 'Successful' ? '#ECFDF3' : '#FEF3F2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Successful' ? '#12B76A' : '#B42318'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    }
]


// ================== AIRTIME REPORT ==============


export const airtimeReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.airtime.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.name')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountName}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount)}</AppText>,
        minWidth: '18rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.network')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.network}</AppText>,
        width: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.phone')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.phoneNumber}</AppText>,
        width: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.transactionDateTime ? helpers.handleDate(row.transactionDateTime) : row?.transactionDateTime}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.airtime.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.status === 'Successful' ? '#ECFDF3' : '#FEF3F2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Successful' ? '#12B76A' : '#B42318'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    }
]

// ====================CUSTOMER PROFILE REPORT ============

export const customerProfileReportColumn = (handleView: any, t:any) => {
    return [
        {
            name: <p className="table-column-title">{t('customer.profile.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.username')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.username}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.id')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.firstName')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.firstName}</AppText>,
            width: '20rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.lastName')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.lastName}</AppText>,
            width: '20rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.primary')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.primaryAccount}</AppText>,
            width: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.phone')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.phoneNumber}</AppText>,
            wrap: true,
            minWidth: '17rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.email')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.emailAddress}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.fullAddress')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.fullAddress}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.creationDate')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.creationDate ? helpers.handleDate(row.creationDate) : row?.creationDate}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.lastLoginDate')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.lastLoginDate ? helpers.handleDate(row.lastLoginDate) : row?.lastLoginDate}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.onboardingMethod')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.onboardingMethod}</AppText>,
            wrap: true,
            minWidth: '17rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.blockedTransactions')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.blockTransactions ? 'Yes' : 'No'}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.gender')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.gender}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.referralCode')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.referralCode}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.status')}</p>,
            minWidth: '17rem',
            selector:(row: any) => (
                <GridContainer 
                    width='auto' sizeUnit="" minHeight='2.2'
                    bgColor={row.isOnboardingCompleted ? '#ECFDF3' : '#FEF3F2'} 
                    topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                >
                    <AppSpan 
                        color={row.isOnboardingCompleted ? '#12B76A' : '#B42318'} 
                        textSize='1.2' leftPadding='0.5' fontWeight='500'
                    >
                        {row.isOnboardingCompleted ? 'Completed' : 'Pending'}
                    </AppSpan>
                </GridContainer>
            ),
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.onboardingDate')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.creationDate ? helpers.handleDate(row.creationDate) : row?.creationDate}</AppText>,
            wrap: true,
            minWidth: '20rem'
        },
        {
            name: <p className="table-column-title">{t('customer.profile.table.lockedStatus')}</p>,
            minWidth: '18rem',
            selector:(row: any) => (
                <GridContainer 
                    width='auto' sizeUnit="" minHeight='2.2'
                    bgColor={!row.isLocked ? '#ECFDF3' : '#FEF3F2'} 
                    topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                >
                    <AppSpan 
                        color={!row.isLocked ? '#12B76A' : '#D30202'} 
                        textSize='1.2' leftPadding='0.5' fontWeight='500'
                    >
                        {!row.isLocked ? 'Unlocked' : 'Locked'}
                    </AppSpan>
                </GridContainer>
            ),
        },
        {
            selector:(row: any) => 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    {t('customer.profile.table.viewDetails')}
                </AppText>,
            minWidth: '12rem'
        }
    ]
}

export const customerProfileReportData = [
    {
        username: "Rhydhur",
        customerID: "360002892",
        onboardingDate: '2023-04-10T03:34:10',
        lastLoginDate: '2023-04-10T03:34:10',
        creationDate: '2023-04-10T03:34:10',
        status: 'Active',
        referralCode: 'Tw762722',
        gender: 'Male',
        blockedTransaction: 'Lorem ipsum',
        address: 'Lorem ipsum',
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        username: "Rhydhur",
        customerID: "360002892",
        onboardingDate: '2023-04-10T03:34:10',
        lastLoginDate: '2023-04-10T03:34:10',
        creationDate: '2023-04-10T03:34:10',
        status: 'Inactive',
        referralCode: 'Tw762722',
        gender: 'Male',
        blockedTransaction: 'Lorem ipsum',
        address: 'Lorem ipsum',
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        username: "Rhydhur",
        customerID: "360002892",
        onboardingDate: '2023-04-10T03:34:10',
        lastLoginDate: '2023-04-10T03:34:10',
        creationDate: '2023-04-10T03:34:10',
        status: 'Active',
        referralCode: 'Tw762722',
        gender: 'Male',
        blockedTransaction: 'Lorem ipsum',
        address: 'Lorem ipsum',
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        username: "Rhydhur",
        customerID: "360002892",
        onboardingDate: '2023-04-10T03:34:10',
        lastLoginDate: '2023-04-10T03:34:10',
        creationDate: '2023-04-10T03:34:10',
        status: 'Active',
        referralCode: 'Tw762722',
        gender: 'Male',
        blockedTransaction: 'Lorem ipsum',
        address: 'Lorem ipsum',
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    }
]


// ====================== CUSTOMER LOGIN =============

export const customerLoginReportColumn =(t:any) => {
    return ([
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.username')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.username}</AppText>,
        wrap: true,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.device')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.deviceID}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.platform')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.isMobile ? 'MOBILE' : 'WEB'}</AppText>,
        width: '12rem'
    },
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.timeAttempted ? helpers.handleDate(row.timeAttempted) : row?.timeAttempted}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.customerLoginReport.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.isSuccessful ? '#ECFDF3' : '#FEF3F2'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.isSuccessful ? '#12B76A' : '#B42318'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.isSuccessful ? 'Successful' : 'Failed'}
                </AppSpan>
            </GridContainer>
        ),
    },
])
}

export const customerLoginReportData = [
    {
        username: 'Elnino',
        deviceID: '199289ahw7892',
        customerID: '360002892',
        loginDate: '2023-04-10T03:34:10'
    },
    {
        username: 'Rhydhur',
        deviceID: '199289ahw7892',
        customerID: '360002892',
        loginDate: '2023-04-10T03:34:10'
    },
    {
        username: 'CR7',
        deviceID: '199289ahw7892',
        customerID: '360002892',
        loginDate: '2023-04-10T03:34:10'
    },
    {
        username: 'Elnino',
        deviceID: '199289ahw7892',
        customerID: '360002892',
        loginDate: '2023-04-10T03:34:10'
    }
]

// ================== FAILED TX REPORT ===============

export const failedTxReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.transactionDate ? helpers.handleDate(row.transactionDate) : row?.transactionDate}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.reference')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.transactionReference}</AppText>,
        wrap: true,
        minWidth: '20rem'
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.profile')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.profileID}</AppText>,
        wrap: true,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        width: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.beneficiary')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.beneficiaryName}</AppText>,
        width: '25rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount, true)}</AppText>,
        width: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.failedTrnx.table.logged')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.loggedAt ? helpers.handleDate(row.loggedAt) : row?.loggedAt}</AppText>,
        width: '20rem'
    },
    // {
    //     name: <p className="table-column-title">Status</p>,
    //     minWidth: '20rem',
    //     selector:(row: any) => (
    //         <GridContainer 
    //             width='auto' sizeUnit="" minHeight='2.2'
    //             bgColor={row.status === 'Disbursed' ? '#F9F5FF' : row.status === 'Expired' ? '#FFF5F5' : '#FEF0C7'} 
    //             topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
    //         >
    //             <AppSpan 
    //                 color={row.status === 'Disbursed' ? '#5925DC' : row.status === 'Expired' ? '#DC2525' : '#B54708'} 
    //                 textSize='1.2' leftPadding='0.5' fontWeight='500'
    //             >
    //                 {row.status}
    //             </AppSpan>
    //         </GridContainer>
    //     ),
    // }
]

export const manageSurveyColumn = (t: any, handleView: (row: any) => void) => {
    return [
        {
            name: <p className="table-column-title">{t('manageSurvey.table.serialNumber')}</p>,
            selector: (row: any, index: number) => (
                <AppText textSize="1.4" color="#667085">
                    {index + 1}
                </AppText>
            ),
            sortable: true,
            width: "8rem",
        },

        {
            name: <p className="table-column-title">{t('manageSurvey.table.triggerName')}</p>,
            selector: (row: any) => (
                <AppText textSize="1.4" color="#667085">
                    {row.triggerName}
                </AppText>
            ),
            wrap: true,
            minWidth: "12rem",
        },

        {
            name: <p className="table-column-title">{t('manageSurvey.table.description')}</p>,
            selector: (row: any) => (
                <AppText textSize="1.4" color="#667085">
                    {row.triggerDescription}
                </AppText>
            ),
            wrap: true,
            minWidth: "20rem",
        },

        {
            name: <p className="table-column-title">{t('manageSurvey.table.interval')}</p>,
            selector: (row: any) => (
                <AppText textSize="1.4" color="#667085">
                    {row.surveyInterval}
                </AppText>
            ),
            wrap: true,
            minWidth: "12rem",
        },

        {
            name: <p className="table-column-title">{t('manageSurvey.table.createdAt')}</p>,
            selector: (row: any) => (
                <AppText textSize="1.4" color="#667085">
                    {new Date(row.createdAt).toLocaleString()}
                </AppText>
            ),
            wrap: true,
            minWidth: "16rem",
        },

        {
            selector: (row: any) =>
                <AppText
                    textSize='1.4' color="#0D968F"
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    {t('manageSurvey.table.view')}
                </AppText>,
            minWidth: '12rem',
        },
    ];
};



export const surveyDetailsColumn = (t: any, handleView: (row: any) => void) => {
    return [
        {
            name: <p className="table-column-title">S/N</p>,
            selector: (row: any, index: number) => (
                <AppText textSize="1.4" color="#667085">
                    {index + 1}
                </AppText>
            ),
            sortable: true,
            width: "8rem",
        },

        {
            name: <p className="table-column-title">Questions</p>,
            selector: (row: any) => (
                <AppText textSize="1.4" color="#667085">
                    {row?.questionText}
                </AppText>
            ),
            wrap: true,
            minWidth: "12rem",
        },

        {
            name: <p className="table-column-title">Type</p>,
            minWidth: '20rem',
            selector: (row: any) => {
                let bgColor = '#FEF3F2';
                let textColor = '#B42318';
                let statusText = '';
                switch (row.surveyType) {
                    case 'Rating':
                        bgColor = '#E0F2FE';
                        textColor = '#0369A1';
                        statusText = 'Rating';
                        break;
                    case 'TrueFalse':
                        bgColor = '#ECFDF3';
                        textColor = '#12B76A';
                        statusText = 'True False';
                        break;

                    case 'FreeText':
                        bgColor = '#F4F3FF';
                        textColor = '#5925DC';
                        statusText = 'Free Text';
                        break;

                }
                return (
                    <GridContainer
                        width='auto' sizeUnit="" minHeight='2.2'
                        bgColor={bgColor}
                        topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                    >
                        <AppSpan
                            color={textColor}
                            textSize='1.2' leftPadding='0.5' fontWeight='500'
                        >
                            {statusText}
                        </AppSpan>
                    </GridContainer>
                )
            },
        },

        {
            selector: (row: any) =>
                <AppText
                    textSize='1.4' color="#0D968F"
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    <FiEdit size={20} color="##0A756F" />

                </AppText>,
            minWidth: '12rem',
        },
    ];
};


export const surveyReportColumn = (t: any, surveyTriggers: ISurveyTriggers[]) => {
  return [
    {
      name: <p className="table-column-title">{t('surveyReport.table.serialNumber')}</p>,
      selector: (row: any) => {
        return (
          <AppText textSize="1.4" color="#667085">
            {row.sn}
          </AppText>
        );
      },
      sortable: true,
      width: "8rem",
    },

    {
      name: <p className="table-column-title">{t('surveyReport.table.surveyType')}</p>,
      selector: (row: any) => {
        const trigger = surveyTriggers.find(
          (trigger) => trigger.id === row.surveyTriggerID
        );
        return (
          <AppText textSize="1.4" color="#667085">
            {trigger ? trigger.triggerName : t('surveyReport.table.notAvailable')}
          </AppText>
        );
      },
      wrap: true,
      minWidth: "12rem",
    },
    {
      name: <p className="table-column-title">{t('surveyReport.table.profileID')}</p>,
      selector: (row: any) => (
        <AppText textSize="1.4" color="#667085">
          {row.profileID}
        </AppText>
      ),
      wrap: true,
      minWidth: "8rem",
    },
    {
      name: <p className="table-column-title">{t('surveyReport.table.questionType')}</p>,
      selector: (row: any) =>
        row.responses.map((response: any) => {
          const questionType = response?.QuestionType || response?.questionType;
          return (
            <div>
              <AppText textSize="1.4" color="#667085">
                {questionType}
              </AppText>
            </div>
          );
        }),

      wrap: true,
      minWidth: "8rem",
    },
    {
      name: <p className="table-column-title">{t('surveyReport.table.responses')}</p>,
      selector: (row: any) =>
        row.responses?.map((response: any) => {
          const answer = response?.Answer || response?.answer;
          const question = response?.Question || response?.question;
          return (
            <div>
              <AppText textSize="1.4" color="#667085">
                {question} : <b>{answer} </b>
              </AppText>
            </div>
          );
        }),
      wrap: true,
      minWidth: "20rem",
    },
  ];
};

export const failedTxReportData = [
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002892',
        accountNumber: '0014337218',
        beneficiaryName: 'John Doe',
        amount: '250000',
        status: 'Expired'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002892',
        accountNumber: '0014337218',
        beneficiaryName: 'John Doe',
        amount: '250000',
        status: 'Awaiting Confirmation'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002892',
        accountNumber: '0014337218',
        beneficiaryName: 'John Doe',
        amount: '250000',
        status: 'Expired'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002892',
        accountNumber: '0014337218',
        beneficiaryName: 'John Doe',
        amount: '250000',
        status: 'Disbursed'
    }
]

// ===================== TX LIMIT REPORT =============

export const txLimitReportColumn = (t:any) => [
    {
        name: <p className="table-column-title">{t('report.txLimit.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.txLimit.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.profileID}</AppText>,
        wrap: true,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">{t('report.txLimit.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        wrap: true,
        minWidth: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.txLimit.table.single')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{moneyFormat(row.oneTimeLimit, true)}</AppText>,
        wrap: true,
        minWidth: '12rem'
    },
    {
        name: <p className="table-column-title">{t('report.txLimit.table.daily')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{moneyFormat(row.dailyLimit, true)}</AppText>,
        wrap: true,
        minWidth: '12rem'
    }
]

export const txLimitReportData = [
    {
        customerID: '360002892',
        singleTransferLimit: 'XXXXXXXXX',
        dailyTransferLimit: 'XXXXXXXXX',
        dateCreated: '2023-04-10T03:34:10'
    },
    {
        customerID: '3600078892',
        singleTransferLimit: 'XXXXXXXXX',
        dailyTransferLimit: 'XXXXXXXXX',
        dateCreated: '2023-04-10T03:34:10'
    },
    {
        customerID: '360002820',
        singleTransferLimit: 'XXXXXXXXX',
        dailyTransferLimit: 'XXXXXXXXX',
        dateCreated: '2023-04-10T03:34:10'
    },
    {
        customerID: '360002492',
        singleTransferLimit: 'XXXXXXXXX',
        dailyTransferLimit: 'XXXXXXXXX',
        dateCreated: '2023-04-10T03:34:10'
    }
]

// ================== FIXED DEPOSIT ================

export const fixedDepositReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.product')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.productCode}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount, true)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.interest')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.interestRate}%</AppText>,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.tenure')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.tenureInDays} {t('report.fixedDeposit.table.day')}</AppText>,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.mature')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.maturationDate ? helpers.handleDate(row.maturationDate) : row?.maturationDate}</AppText>,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: <p className="table-column-title">{t('report.fixedDeposit.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.accountStatus === 'Active' ? '#F9F5FF' : row.accountStatus === 'Closed' ? '#FFF5F5' : '#FEF0C7'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.accountStatus === 'Active' ? '#5925DC' : row.accountStatus === 'Closed' ? '#DC2525' : '#B54708'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.accountStatus}
                </AppSpan>
            </GridContainer>
        ),
    }
]

export const fixedDepositReportData = [
    {
        accountNumber: '0014337281',
        productCode: 'XXXXXXXX',
        amount: '35000000',
        interestRate: '3.5',
        tenure: 30,
        dateCreated: '2023-04-10T03:34:10',
        status: 'Closed'
    },
    {
        accountNumber: '0014337281',
        productCode: 'XXXXXXXX',
        amount: '35000000',
        interestRate: '3.5',
        tenure: 30,
        dateCreated: '2023-04-10T03:34:10',
        status: 'Active'
    },
    {
        accountNumber: '0014337281',
        productCode: 'XXXXXXXX',
        amount: '35000000',
        interestRate: '3.5',
        tenure: 30,
        dateCreated: '2023-04-10T03:34:10',
        status: 'Closed'
    },
    {
        accountNumber: '0014337281',
        productCode: 'XXXXXXXX',
        amount: '35000000',
        interestRate: '3.5',
        tenure: 30,
        dateCreated: '2023-04-10T03:34:10',
        status: 'Active'
    }
]

// ============= CARDLESS WITHDRAWAL REPORT ============

export const cardlessWithdrawalReportColumn = [
    {
        name: <p className="table-column-title">S/N</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">Date</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.date ? helpers.handleDate(row.date) : row?.date}</AppText>,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: <p className="table-column-title">Customer Name</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerName}</AppText>,
        minWidth: '20rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">Customer ID</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">Amount</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.amount)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">Status</p>,
        minWidth: '20rem',
        selector:(row: any) => (
            <GridContainer 
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.status === 'Disbursed' ? '#F9F5FF' : row.status === 'Expired' ? '#FFF5F5' : '#FEF0C7'} 
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan 
                    color={row.status === 'Disbursed' ? '#5925DC' : row.status === 'Expired' ? '#DC2525' : '#B54708'} 
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.status}
                </AppSpan>
            </GridContainer>
        ),
    }
]


export const cardlessWithdrawalReportData = [
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Disbursed'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Awaiting Confrimation'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Disbursed'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Expired'
    }
]

// ================== LOANS REPORT ===============

export const loansReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('report.loans.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.loans.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.dateCreated ? helpers.handleDate(row.dateCreated) : row?.dateCreated}</AppText>,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: <p className="table-column-title">{t('report.loans.table.name')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerName}</AppText>,
        minWidth: '25rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.loans.table.id')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.loans.table.amount')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.loanAmount)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.loans.table.status')}</p>,
        selector:(row: any) => (<p className='text-[#ccc] '>{capsule(row.realLoanStatus)}</p>),
        minWidth: '15rem',
        wrap: true
    },
]


export const loansReportData = [
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Disbursed'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Awaiting Confrimation'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Disbursed'
    },
    {
        date: '2023-04-10T03:34:10',
        customerName: 'Ridwan Kolawole',
        customerID: '360002492',
        amount: '33500',
        status: 'Expired'
    }
]

// ============ TARGET SAVINGS REPORT ============

export const targetSavingsReportColumn = (t:any) => [
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.account')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.target')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.targetAmount, true)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.debit')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">₦{moneyFormat(row.debitAmount, true)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.interest')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.interestRate}%</AppText>,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.tenure')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.tenure} {t('report.targetSavings.table.day')}</AppText>,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.frequency')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.frequency}</AppText>,
        wrap: true,
        minWidth: '12rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.mature')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.maturityDate ? helpers.handleDate(row.maturityDate) : row?.maturityDate}</AppText>,
        wrap: true,
        minWidth: '20rem',
    },
    {
        name: <p className="table-column-title">{t('report.targetSavings.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.startDate ? helpers.handleDate(row.startDate) : row?.startDate}</AppText>,
        wrap: true,
        minWidth: '20rem',
    }
]

export const targetSavingsReportDate = [
    {
        accountNumber: '0123456789',
        targetAmount: '420000',
        debitAmount: '15000',
        interestRate: '2.3',
        tenure: '90',
        frequency: 'XXXXXXXX',
        maturityDate: '2023-04-10T03:34:10',
        startDate: '2023-04-10T03:34:10'
    },
    {
        accountNumber: '0123456789',
        targetAmount: '420000',
        debitAmount: '15000',
        interestRate: '2.3',
        tenure: '90',
        frequency: 'XXXXXXXX',
        maturityDate: '2023-04-10T03:34:10',
        startDate: '2023-04-10T03:34:10'
    },
    {
        accountNumber: '0123456789',
        targetAmount: '420000',
        debitAmount: '15000',
        interestRate: '2.3',
        tenure: '90',
        frequency: 'XXXXXXXX',
        maturityDate: '2023-04-10T03:34:10',
        startDate: '2023-04-10T03:34:10'
    }
]

// =============== Institutions ====================

export const institutionsColumn = (handleView: any, t:any) => {
    return [
        {
            name: <p className="table-column-title">{t('report.institutions.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.institution')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.name}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.bankOneCode')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.institutionCode}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.ibInstitutionCode')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.id}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.alias')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.alias}</AppText>,
            width: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.phone')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.correspondencePhone}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.email')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.correspondenceEmail}</AppText>,
            wrap: true,
            minWidth: '15rem'
        },
        {
            name: <p className="table-column-title">{t('report.institutions.table.setup')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.setupDate ? helpers.handleDate(row.setupDate) : row?.setupDate}</AppText>,
            wrap: true,
            minWidth: '22rem',
        },
        {
            selector:(row: any) => 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    {t('report.institutions.table.view')}
                </AppText>,
            minWidth: '12rem',
        },
    ]
}

export const institutionsData = [
    {
        institutionName: 'Fidelity Bank',
        username: "Rhydhur",
        nipCode: "cBG-Xyz",
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        institutionName: 'Fidelity Bank',
        username: "Rhydhur",
        nipCode: "cBG-Xyz",
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        institutionName: 'Fidelity Bank',
        username: "Rhydhur",
        nipCode: "cBG-Xyz",
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    },
    {
        institutionName: 'Fidelity Bank',
        username: "Rhydhur",
        nipCode: "cBG-Xyz",
        email: 'test@gmail.com',
        phoneNumber: 'XXXXXXXX',
        primaryAccount: 'Mobile',
        firstName: "Ridwan",
        lastName: 'Kolawole'
    }
]


// ============ AUDIT REPORT =====================

export const auditReportColumn = (handleView: any, t:any) => {
    return [
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.institutionName')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.institutionName}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.userId')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.userID}</AppText>,
            minWidth: '17rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.action')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.action}</AppText>,
            wrap: true,
            minWidth: '22rem',
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.model')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.model}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.dateStart')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.loggedAt ? helpers.handleDate(row.loggedAt) : row?.loggedAt}</AppText>,
            wrap: true,
            minWidth: '20rem',
        },
        {
            name: <p className="table-column-title">{t('audit.auditReport.table.dateEnd')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.loggedAt ? helpers.handleDate(row.loggedAt) : row?.loggedAt}</AppText>,
            wrap: true,
            minWidth: '20rem',
        },
        {
            selector:(row: any) => 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    View Details
                </AppText>,
            minWidth: '12rem'
        },
    ]
}


export const auditReportData = [
    {
        date: '2023-04-10T03:34:10',
        username: 'Ridwan Kolawole',
        actionPerformed: 'I created an institution with all configurations',
        processOutput: 'Null'
    },
    {
        date: '2023-04-10T03:34:10',
        username: 'Ridwan Kolawole',
        actionPerformed: 'I created an institution with all configurations',
        processOutput: 'Null'
    },
    {
        date: '2023-04-10T03:34:10',
        username: 'Ridwan Kolawole',
        actionPerformed: 'I created an institution with all configurations',
        processOutput: 'Null'
    },
    {
        date: '2023-04-10T03:34:10',
        username: 'Ridwan Kolawole',
        actionPerformed: 'I created an institution with all configurations',
        processOutput: 'Null'
    }
]


// =================== LOGIN AUDIT REPORT =============

export const loginReportColumn =(t:any) => [
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.no')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
        sortable: true,
        width: '8rem'
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.institutionName')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.institutionName}</AppText>,
        minWidth: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.username')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.username}</AppText>,
        minWidth: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.userId')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.userID}</AppText>,
        minWidth: '17rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.status')}</p>,
        selector:(row: any) => (
            <GridContainer
                width='auto' sizeUnit="" minHeight='2.2'
                bgColor={row.isSuccessful? '#ECFDF6' : '#FEF3F2'}
                topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
            >
                <AppSpan
                    color={row.isSuccessful ? '#12B76A' : '#B42318'}
                    textSize='1.2' leftPadding='0.5' fontWeight='500'
                >
                    {row.isSuccessful ? 'Successful' : 'Failed'}
                </AppSpan>
            </GridContainer>
        ),
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.time')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.timeAttempted ? helpers.splitDateTime(row.timeAttempted).completeTime : row?.timeAttempted}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('audit.loginReport.table.date')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.timeAttempted ? helpers.splitDateTime(row.timeAttempted).date : row?.timeAttempted}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    // {
    //     name: <p className="table-column-title">Logout date</p>,
    //     selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.logoutDate ? helpers.handleDate(row.logoutDate) : row?.logoutDate}</AppText>,
    //     wrap: true,
    //     minWidth: '20rem',
    // },
]


export const loginReportData = [
    {
        loginDate: '2023-04-10T03:34:10',
        username: 'Rhydhur',
        logoutDate: '2023-04-10T03:38:10'
    },
    {
        loginDate: '2023-04-10T03:34:10',
        username: 'Rhydhur',
        logoutDate: '2023-04-10T03:38:10'
    },
    {
        loginDate: '2023-04-10T03:34:10',
        username: 'Rhydhur',
        logoutDate: '2023-04-10T03:38:10'
    },
    {
        loginDate: '2023-04-10T03:34:10',
        username: 'Rhydhur',
        logoutDate: '2023-04-10T03:38:10'
    }
]


// ================== USERS===================

export const usersColumn = (t:any,activateUser? :any, deactivateUser?:any, handleRepushEmail?: any, handleEdit?:any) => {
    return [
        {
            name: <p className="table-column-title">{t('users.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('users.table.username')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.username}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.fullName')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.firstName} {row.lastName}</AppText>,
            minWidth: '20rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.email')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.email}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.phone')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.phoneNumber}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.role')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{utility.getRoleName(row.role)}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.code')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.ibInstitutionCode}</AppText>,
            minWidth: '15rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('users.table.date')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.creationDate ? helpers.splitDateTime(row.creationDate).date : row?.creationDate}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        // {
        //     name: <p className="table-column-title">Changed password</p>,
        //     selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.isPasswordChanged ? 'TRUE' : 'FALSE'}</AppText>,
        //     minWidth: '12rem',
        //     wrap: true,
        // },
        {
            selector:(row: any) => 
                (handleEdit) ? 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleEdit(row)}
                >
                    {t('users.table.edit')}
                </AppText>
                : null,
            minWidth: '15rem',
      },
        {
            selector:(row: any) => 
                (handleRepushEmail && !row.isPasswordChanged) ? 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleRepushEmail(row)}
                >
                    {t('users.table.repush')}
                </AppText>
                : null,
            minWidth: '15rem',
      },
      {
        selector: (row: any) => 
          (activateUser && deactivateUser) ? 
          <Button
            width='14.1' bgColor={row.isActive ? '#FEF3F2' : '#E7F6F5'}
            titleSize='1.4' fontWeight='600'
            height='4' radius='0.8' color={row.isActive ? '#D30202' : '#0D968F'}
            bottomMargin='1' hoverColor={row.isActive ? '#D30202' : '#0D968F'}
            hoverBgColor='#fff' hoverBorderColor={row.isActive ? '#D30202' : '#0D968F'}
            onClick={() => { row.isActive ? deactivateUser(row) : activateUser(row) }}
          >
            {row.isActive ? t('users.table.deactivate') : t('users.table.activate')}
          </Button> 
          : null
        

        , minWidth: '20rem',

      }
    ]
}


export const usersData = [
    {
        fullName: 'Ridwan Kolawole',
        username: 'Rhydhur',
        email: 'example@gmaIL.com',
        phoneNumber: '08062718291',
        isActive: true,
        isUnlocked: true
    },
    {
        fullName: 'Ridwan Kolawole',
        username: 'Rhydhur',
        email: 'example@gmaIL.com',
        phoneNumber: '08062718291',
        isActive: false,
        isUnlocked: false
    },
    {
        fullName: 'Ridwan Kolawole',
        username: 'Rhydhur',
        email: 'example@gmaIL.com',
        phoneNumber: '08062718291',
        isActive: true,
        isUnlocked: false
    },
    {
        fullName: 'Ridwan Kolawole',
        username: 'Rhydhur',
        email: 'example@gmaIL.com',
        phoneNumber: '08062718291',
        isActive: true,
        isUnlocked: true
    }
]


export const accountUpgradeRequestColumn = (handleView: any, t:any) => {
    return [
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.customerId')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
            minWidth: '17rem',
            wrap: true,
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.accountNumber')} </p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.nin')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.nin}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.bvn')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.bvn}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.status')}</p>,
            minWidth: '20rem',
            selector:(row: any) => (
                <GridContainer 
                    width='auto' sizeUnit="" minHeight='2.2'
                    bgColor={row.status === 'cCOMPLETED' ? '#ECFDF3' : row.status === 'REJECTED' ? '#FFF5F5' : '#FEF0C7'}
                    topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                >
                    <AppSpan 
                        color={row.status === 'COMPLETED' ? '#027A48' : row.status === 'REJECTED' ? '#DC2525' : '#B54708'} 
                        textSize='1.2' leftPadding='0.5' fontWeight='500'
                    >
                        {row.status}
                    </AppSpan>
                </GridContainer>
            ),
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.date')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.requestedAt ? helpers.handleDate(row.requestedAt) : row?.requestedAt}</AppText>,
            wrap: true,
            minWidth: '20rem',
        },
        {
            name: <p className="table-column-title">{t('customer.upgrade.table.isUpgraded')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.isUpgraded ? 'TRUE' : 'FALSE'}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            selector:(row: any) => 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    {t('customer.upgrade.table.viewDetails')}
                </AppText>,
            minWidth: '12rem'
        }
    ]
}

export const accountOpeningRequestColumn = (handleView: any, t:any) => {
    return [
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.no')}</p>,
            selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.sn}</AppText>,
            sortable: true,
            width: '8rem'
        },
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.fullName')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.fullName}</AppText>,
            minWidth: '17rem',
            wrap: true,
        },
            {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.customerID')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.customerID}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.email')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.email}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.dob')}</p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.dateOfBirth ? helpers.handleDate(row?.dateOfBirth) : row?.dateOfBirth}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.accountNumber')} </p>,
            selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.accountNumber}</AppText>,
            wrap: true,
            minWidth: '15rem',
        },
        {
            name: <p className="table-column-title">{t('customer.nonNigerianAccount.table.status')}</p>,
            minWidth: '20rem',
            selector:(row: any) => (
                <GridContainer 
                    width='auto' sizeUnit="" minHeight='2.2'
                    bgColor={row.isAccountApproved === true ? '#ECFDF3' : row.isAccountApproved === false ? '#FFF5F5' : '#FEF0C7'}
                    topPadding='0' bottomPadding='0' padding='0.8' radius='1.6'
                >
                    <AppSpan 
                        color={row.isAccountApproved === true ? '#027A48' : row.isAccountApproved === false ? '#DC2525' : '#B54708'} 
                        textSize='1.2' leftPadding='0.5' fontWeight='500'
                    >
                        {row.isAccountApproved === true? "Approved" : "Rejected"}
                    </AppSpan>
                </GridContainer>
            ),
        },
        {
            selector:(row: any) => 
                <AppText 
                    textSize='1.4' color="#0D968F" 
                    hoverColor="#667085" cursor="pointer"
                    onClick={() => handleView(row)}
                >
                    {t('customer.upgrade.table.viewDetails')}
                </AppText>,
            minWidth: '12rem'
        }
    ]
}

export const accountUpgradeRequestData = [
    {
        id: 1,
        customerID: '17872782',
        accountNumber: '0829237828',
        bvn: '2238399393',
        nin: '8919272982',
        status: 'COMPLETED',
        requestedAtStartTime: '2024-08-19T09:58:32.089Z',
        isUpgraded: true
    },
    {
        id: 2,
        customerID: '17872782',
        accountNumber: '0829237828',
        bvn: '2238399393',
        nin: '8919272982',
        status: 'PENDING',
        requestedAtStartTime: '2024-08-19T09:58:32.089Z',
        isUpgraded: false
    }
]


export const buildReportColumn =(t:any)=> {
  return  [
    {
        name: <p className="table-column-title">{t('report.buildReport.institutionCode')}</p>,
        selector: (row: any) => <AppText textSize='1.4' color="#667085">{row.ibInstitutionCode}</AppText>,
        sortable: true,
        width: '15rem'
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.institutionName')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.institutionName}</AppText>,
        wrap: true,
        minWidth: '35rem',
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.buildType')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row.buildType}</AppText>,
        minWidth: '15rem',
        wrap: true,
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.status')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{capsule(row.statusMessage)}</AppText>,
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.download')}</p>,
        selector:(row: any) => (
        <div style={{width:'100px',display:'flex', justifyContent:'center'}}>
            {!!row.lastBuildUrl ?
             (<a 
                href={`https:/${row.lastBuildUrl}`} rel="noreferrer" target="_blank"  
                className="download-apk-btn" >
                <img src={ApkDownloadIcon} width={20} height={20} alt="download"/>
            </a>):
            (<div className='download-apk-btn-disabled' >
                <img src={ApkDownloadIcon} width={20} height={20} alt="download"/>
            </div>)}
        </div>
        ),
        wrap: true,
        minWidth: '15rem',
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.lastBuildDate')}</p>,
        selector:(row: any) => <AppText textSize='1.4' color="#667085">{row?.currentBuildStartDateTime ? helpers.handleDate(row.currentBuildStartDateTime) : row?.currentBuildStartDateTime}</AppText>,
        wrap: true,
        minWidth: '25rem',
    },
    {
        name: <p className="table-column-title">{t('report.buildReport.lastBuildCompletion')}</p>,
        selector:(row: any) => (<AppText textSize='1.4' color="#667085">{row?.currentBuildCompletionDateTime ? helpers.handleDate(row.currentBuildCompletionDateTime) : row?.currentBuildCompletionDateTime}</AppText>),
        minWidth: '25rem',
        wrap: true
    },
]
}